import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, TransitionGroup as _TransitionGroup, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0b3b6ce0")

_pushScopeId("data-v-0b3b6ce0")
const _hoisted_1 = { class: "surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden" }
const _hoisted_2 = { class: "flex flex-column align-items-center justify-content-center" }
const _hoisted_3 = { class: "login" }
const _hoisted_4 = {
  class: "w-full surface-card py-8 px-5 sm:px-8",
  style: {"border-radius":"53px"}
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "text-center image" }, [
  /*#__PURE__*/_createVNode("img", {
    style: {"width":"75%"},
    src: "assets/layout/images/logo/logo.png"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  for: "tokucd",
  class: "block text-900 text-xl font-medium mb-2"
}, "企業ID", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("label", {
  for: "userid",
  class: "block text-900 text-xl font-medium mb-2"
}, "ユーザーID", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  for: "password",
  class: "block text-900 font-medium text-xl mb-2"
}, "パスワード", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_zMessage = _resolveComponent("zMessage")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_TransitionGroup, {
            name: "z-message",
            tag: "div"
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.wMessage, (msg) => {
                return (_openBlock(), _createBlock(_component_zMessage, {
                  severity: msg.severity,
                  key: msg.id
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(msg.content), 1)
                  ]),
                  _: 2
                }, 1032, ["severity"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode("div", null, [
            _hoisted_6,
            _createVNode(_component_InputText, {
              modelValue: _ctx.mLogin.TOKUID,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mLogin.TOKUID = $event)),
              id: "tokucd",
              type: "text",
              placeholder: "企業ID",
              class: "w-full md:w-30rem mb-5",
              style: {"padding":"1rem"}
            }, null, 8, ["modelValue"]),
            _hoisted_7,
            _createVNode(_component_InputText, {
              modelValue: _ctx.mLogin.USERID,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.mLogin.USERID = $event)),
              id: "userid",
              type: "text",
              placeholder: "ユーザーID",
              class: "w-full md:w-30rem mb-5",
              style: {"padding":"1rem"}
            }, null, 8, ["modelValue"]),
            _hoisted_8,
            _createVNode(_component_InputText, {
              type: "password",
              modelValue: _ctx.mLogin.PASSWD,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.mLogin.PASSWD = $event)),
              placeholder: "パスワード",
              class: "w-full mb-3",
              inputClass: "w-full",
              inputStyle: "padding:1rem"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              label: "ログイン",
              onClick: _ctx.fncLogin,
              class: "w-full p-3 text-xl"
            }, null, 8, ["onClick"])
          ])
        ])
      ])
    ])
  ]))
})